module.exports = __webpack_public_path__ + "static/media/HB_caesarsalad_square_forweb.4d4f1f23.jpg";